if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.onClick = this.onClick.bind(this);
      this.requestVisibilityUpdate = this.requestVisibilityUpdate.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.requestVisibilityUpdate, { passive: true });
      window.addEventListener('resize', this.requestVisibilityUpdate);
      window.addEventListener('pageshow', this.requestVisibilityUpdate);
      this.requestVisibilityUpdate();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.requestVisibilityUpdate);
      window.removeEventListener('resize', this.requestVisibilityUpdate);
      window.removeEventListener('pageshow', this.requestVisibilityUpdate);
      window.cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    requestVisibilityUpdate() {
      if (this.frame !== null) return;
      this.frame = window.requestAnimationFrame(() => {
        const visible = window.scrollY > Math.max(400, window.innerHeight);
        this.classList.toggle('back-to-top--active', visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.frame = null;
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
  }

  customElements.define('back-to-top', BackToTop);
}
